<template>
	<div>
		<el-dialog
		 :title="title_content"
		 :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false"
		 width="600px"
		 @close="submitTap('1')">
		  <el-form :model="form" :rules="rules" ref="ruleForm" style="width:500px;">
		    <el-form-item label="会员手机号码:" prop="user_mobile" :label-width="formLabelWidth">
				<el-input v-model="form.user_mobile" placeholder="请输入手机号码" autocomplete="off"></el-input>
		    </el-form-item>
			<el-form-item label="会员昵称:" :label-width="formLabelWidth">
				<el-input v-model="form.user_nick" placeholder="请输入昵称" autocomplete="off"></el-input>
			</el-form-item>
		    <el-form-item label="选择宠物:" prop="pet_id" :label-width="formLabelWidth">
				<el-select v-model="form.pet_id" placeholder="请选择" style="width:100%;">
					<el-option label="级别一" value="1"></el-option>
					<el-option label="级别二" value="2"></el-option>
					<!--<el-option  v-for="petRow in userPetList" label="{{petRow.pet_name}}" value="{{petRow.pet_id}}"></el-option>-->
				</el-select>
		    </el-form-item>
			<el-form-item label="提醒类型:" prop="notice_type" :label-width="formLabelWidth">
				  <el-select v-model="form.notice_type" placeholder="请选择提醒类型" style="width:100%;">
					  <el-option label="级别一" value="1"></el-option>
					  <el-option label="级别二" value="2"></el-option>
					  <!--<el-option  v-for="noticeTypeRow in noticeTypeList" label="{{noticeTypeRow.notice_type_name}}" value="{{noticeTypeRow.notice_type_id}}"></el-option>-->
				  </el-select>
			</el-form-item>
			<el-form-item label="生日:" prop="notice_date" :label-width="formLabelWidth">
				<el-date-picker
				      v-model="form.notice_date"
				      type="date"
					  style="width:100%;"
				      placeholder="请选择时间">
				    </el-date-picker>
			</el-form-item>
			<el-form-item label="通知方式:" prop="notice_method" :label-width="formLabelWidth">
				  <el-select v-model="form.notice_method" placeholder="请选择" style="width:100%;">
					  <el-option label="级别一" value="1"></el-option>
					  <el-option label="级别二" value="2"></el-option>
					  <!--<el-option  v-for="row in noticeMethodList" label="{{row.notice_method_id}}" value="{{row.notice_method_id}}"></el-option>-->
				  </el-select>
			</el-form-item>
			<el-form-item label="提醒内容:" prop="notice_content" :label-width="formLabelWidth">
				<el-input type="textarea" v-model="form.notice_content" placeholder="请输入需要提醒的内容......" style="height:50px;"></el-input>
				<div style="font-size:8px;line-height: 15px;margin-top:10px;color:grey">
					参考短信内容：<br/>
					距离旺财的上一次驱虫已经60天了，惠心宠物提醒您，它的健康会换来您的快乐。
				</div>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="submitTap('1')">取 消</el-button>
		    <el-button type="FF7" @click="submitTap('2','ruleForm')">保 存</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	var petList = [
		{
		    pet_id:'1',
			pet_name:'卡卡'
		},{
	        pet_id:'2',
			pet_name:'俄罗斯'
		}
	];
	var noticeTypeList = [
        {
            notice_type_id:'1',
            notice_type_name:'生日提醒'
        },{
            pet_id:'2',
            pet_name:'宠物美容'
        }
	];
	var noticeMethodData = [
		{
		    notice_method_id:'1',
			notice_method_name:'短信通知'
		},{
	        notice_method_id:'2',
			notice_method_name:'微信通知'
		}
	];
	export default {
		name:'addNotice',
		props:['status','uid','petId'],
		data() {
		  return {
			userPetList:petList,
			noticeTypeList:noticeTypeList,
			noticeMethodList:noticeMethodData,
			dialogFormVisible:false,
			current_user_id:'',
			current_pet_id:'',
			title_content:'',
			form: {
			  user_mobile:'',
		      user_nick:'',
		      pet_id:'',
		      notice_type:'',
		      notice_date:'',
		      notice_method:'',
		      notice_content:'',
			},
			formLabelWidth: '120px',
			rules: {
			    user_mobile:[
					{required:true,message:'请输入手机号码',trigger:'blur'}
				],
				pet_id:[
					{required:true,message:'请选择宠物',trigger:'change'}
				],
				notice_type:[
					{required:true,message:'请选择提醒类型',trigger:'change'}
				],
				notice_date:[
					{required:true,message:'请选择提醒时间',type:'date',trigger:'change'}
				],
				notice_method:[
					{required:true,message:'请选择通知方式',trigger:'change'}
				],
				notice_content:[
					{required:true,message:'请输入需要提醒的内容',trigger:'blur'}
				],
			}
		  };
		},
		watch:{
			status(val){
				 this.dialogFormVisible = val;
				 this.current_user_id = this.uid;
				 this.current_pet_id = this.petId;
				 this.title_content = '新增店务提醒';
				 if(this.petId){
				     this.title_content = '编辑店务提醒';
				 }
			}
		},
		methods:{
			submitTap(type,obj){
				if(type == '2'){
					this.submitForm(obj);
					return;
				}
				this.dialogFormVisible = false;
				this.$emit('add',false,'')
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					this.messages('新增成功','success');
					this.dialogFormVisible = false;
					this.$emit('add',false,'')
				  } else {
					return false;
				  }
				});
			}
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.search_user_box{height:70px;}
	.pa_main_add_btn{font-size:16px;margin-top:18px;line-height:24px;font-weight:'bold';background:#fff;color:#999;text-align:center;}
	.pa_main_status_box{display:flex;}
	.pa_main_status_box .cols{width:16.6%;margin-left:10px;height:70px;padding:14px 0;color:#fff;border-radius:10px;text-align:center;}
	.pa_main_status_box .cols .numbers{font-size:34px;}
	
	.pa_main_search_inner{display:flex;padding:18px 0;}
	
	.pa_user_info_box{
		background:#fff;border-radius:10px;
		.img{
			width:60px;height:60px;border-radius:50%;
		}
		.text{
			padding:0 0 0 10px;
			.labels{display:block;width:40px;line-height:18px;margin-top:5px;background:#FF700B;text-align:center;color:#fff;font-size:12px;border-radius:6px;}
		}
		.el-icon-arrow-right{position:absolute;right:0;font-size:20px;}
		.over,.card{
			width:50%;text-align:center;
			span{display:block;margin-bottom:5px;font-size:18px;}
		}
		.pa_btn{margin-left:0;}
	}
</style>


// WEBPACK FOOTER //
// addNotice.vue?1a2e401c